import ComboBoxSelectBoxHeaderComponent from "discourse/select-kit/components/combo-box/combo-box-header";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";
import ChannelTitle from "discourse/plugins/chat/discourse/components/channel-title";

export default class ChatChannelChooserHeader extends ComboBoxSelectBoxHeaderComponent {
  <template>
    <div class="select-kit-header-wrapper">
      {{#if this.selectedContent}}
        <ChannelTitle @channel={{this.selectedContent}} />
      {{else}}
        {{i18n "chat.incoming_webhooks.channel_placeholder"}}
      {{/if}}

      {{dIcon this.caretIcon class="angle-icon"}}
    </div>
  </template>
}
